import { render, staticRenderFns } from "./Lucky.vue?vue&type=template&id=c945626c&scoped=true&"
import script from "./Lucky.vue?vue&type=script&lang=js&"
export * from "./Lucky.vue?vue&type=script&lang=js&"
import style0 from "./Lucky.vue?vue&type=style&index=0&id=c945626c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c945626c",
  null
  
)

export default component.exports